import React, { useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

// Custom icon for the marker
const customIcon = new L.Icon({
  iconUrl: "/assets/images/icons/loc_picker.png",
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

const LocationPicker = ({ form }) => {
  const { t } = useTranslation();
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation([latitude, longitude]);
          setLocation({ lat: latitude, lng: longitude });

          // Set default form values
          form.setFieldsValue({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.error("Error getting geolocation", error);
        }
      );
    }
  }, [form]);

  const handleLatChange = (e) => {
    const newLat = parseFloat(e.target.value);
    if (!isNaN(newLat)) {
      const newLocation = { ...location, lat: newLat };
      setLocation(newLocation);
      form.setFieldsValue({ lat: newLat });
    }
  };

  const handleLngChange = (e) => {
    const newLng = parseFloat(e.target.value);
    if (!isNaN(newLng)) {
      const newLocation = { ...location, lng: newLng };
      setLocation(newLocation);
      form.setFieldsValue({ lng: newLng });
    }
  };

  const LocationMarker = () => {
    useMapEvents({
      click(event) {
        const { lat, lng } = event.latlng;
        setLocation({ lat, lng });
        form.setFieldsValue({ lat, lng });
      },
    });

    return location === null ? null : (
      <Marker position={location} icon={customIcon}>
        <Popup>
          {`${t("latitude")}: ${location.lat}, ${t("longitude")}: ${
            location.lng
          }`}
        </Popup>
      </Marker>
    );
  };

  const UpdateMapCenter = () => {
    const map = useMap();
    useEffect(() => {
      if (location.lat && location.lng) {
        map.setView([location.lat, location.lng], map.getZoom());
      }
    }, [location, map]);
    return null;
  };

  return (
    <div style={{ maxWidth: "100%", padding: "20px" }}>
      <h2>{t("select_location")}</h2>

      {userLocation ? (
        <MapContainer
          center={location || userLocation}
          zoom={13}
          detectRetina={true}
          style={{
            height: "250px",
            width: "100%",
            borderRadius: "10px",
          }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
            tileSize={512}
            zoomOffset={-1}
          />

          <LocationMarker />
          <UpdateMapCenter />
        </MapContainer>
      ) : (
        <p>{t("loading_map")}</p>
      )}

      {location && (
        <div style={{ marginTop: "20px", fontSize: "16px" }}>
          <div className="form-row">
            <Form.Item
              name="lat"
              label={t("latitude")}
              rules={[{ required: true }]}
            >
              <Input
                className="input"
                type="number"
                onChange={handleLatChange}
                step="any"
              />
            </Form.Item>
            <Form.Item
              name="lng"
              label={t("longitude")}
              rules={[{ required: true }]}
            >
              <Input
                type="number"
                value={location.lng}
                onChange={handleLngChange}
                step="any"
              />
            </Form.Item>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationPicker;
